<div id="news_content">
    <div id="news_title">{{'NEWS.TITLE' | translate}}</div>
    
    @if(this.newsElements.length > 0){
        @for(newsElement of this.newsElements; track $index){
            @if(!this.maxItems || (this.showAll || $index < this.maxItems)){
                @switch(newsElement.type){
                    @case('news'){
                        <app-news-item class="news_element" [news]="this.getOperationNews(newsElement)" (onLikeNews)="this.refreshNewsElements($event)"/>
                    }
                    @case('question'){
                        <app-news-question class="news_element" [question]="this.getQuestion(newsElement)" (onAnswerQuestion)="this.onAnswerQuestion($event)"/>
                    }
                }                
            }
        }
        
        @if(this.maxItems && !this.showAll && this.newsElements.length > this.maxItems){
            <div class="news_list_btn_show_all" (click)="this.displayAll()">
                <ion-icon name="caret-down-outline"></ion-icon>
            </div>
        }
    }
    @else{
         <demooz-message type="info">{{'NEWS.MSG_NO_NEWS' | translate}}</demooz-message>
    }
    
</div>

<demooz-modal #modalAnswer size="small" (onDidDismiss)="this.onDidDismissModalAnswer($event)">
    @if(this.questionToAnswer){
        <app-questions-answer [question]="this.questionToAnswer" (onSendAnswerQuestion)="this.onSendAnswerQuestion($event)"/>
    }
</demooz-modal>